<template>
    <CurrentFiltersLegacy v-if="!keepFilters" v-bind="props" @invoke-filter="emit('invokeFilter', $event)" />
    <div v-else-if="hasActiveFilters" class="mb-5 min-w-0 max-w-full lg:mb-0" aria-label="Actieve filters" aria-live="polite">
        <div class="flex gap-3 overflow-x-auto lg:flex-wrap lg:gap-0 lg:overflow-visible">
            <button
                v-for="[id, name] in activeFilterNames"
                :key="id"
                type="button"
                class="plp-active-filter mb-2 shrink-0 whitespace-nowrap lg:ml-4 lg:shrink lg:whitespace-normal"
                @click="removePropertyFilter(id)"
                :aria-label="`${name} verwijderen`">
                {{ name }} <XMarkIcon class="size-4 shrink-0 stroke-2" />
            </button>
            <button
                v-if="route.query['min-price'] != null || route.query['max-price'] != null"
                type="button"
                class="plp-active-filter mb-2 shrink-0 whitespace-nowrap lg:ml-4 lg:shrink lg:whitespace-normal"
                @click="clearPriceFilter">
                Prijs: {{ route.query['min-price'] != null ? 'vanaf €' + route.query['min-price'] : '' }}
                {{ route.query['max-price'] != null ? 'tot €' + route.query['max-price'] : '' }}
                <XMarkIcon class="size-4 shrink-0 stroke-2" />
            </button>
            <button
                v-if="route.query.newOnly"
                type="button"
                class="plp-active-filter mb-2 shrink-0 whitespace-nowrap lg:ml-4 lg:shrink lg:whitespace-normal"
                @click="router.push({ query: { ...route.query, newOnly: undefined, p: undefined } })">
                Nieuw <XMarkIcon class="size-4 shrink-0 stroke-2" />
            </button>
            <button type="button" class="plp-clear-filters mb-2 shrink-0 whitespace-nowrap lg:ml-4 lg:shrink lg:whitespace-normal" @click="clearAllFilters">
                {{ $snippets['headless.plp.removeFilters'] || 'Alle filters wissen' }}
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
    import CurrentFiltersLegacy from './CurrentFiltersLegacy.vue';
    const keepFilters = useKeepFilters();
    import { XMarkIcon } from '@heroicons/vue/24/outline';
    const props = defineProps<{ filters?: any[]; currentFilters?: any; isOpen?: boolean }>();
    const emit = defineEmits(['invokeFilter']);
    const route = useRoute();
    const router = useRouter();
    const { hasActiveFilters, activeFilterNames, removePropertyFilter, clearPriceFilter, clearAllFilters } =
        usePlpFilters(computed(() => props.filters || []));
</script>
